import React from "react"
import PropTypes from "prop-types"
import { RichText, Elements } from "prismic-reactjs"
import { linkResolver } from "utils/linkResolver"
import { Icon } from "@mostlycode/ui"
import styled from "styled-components"
import CustomList from "../CustomList"

const StyledSpan = styled.span`
  display: inline-flex;
  align-items: center;
  svg {
    margin: 0 0 0 0.4em;
  }
`

const htmlSerializer = function (type, element, content, children, key) {
  switch (type) {
    case Elements.hyperlink:
      const props = {
        href: element.data.url || linkResolver(element.data),
        target: element.data.target || null,
        rel: element.data.target ? "noopener" : null,
      }
      return (
        <a key={key} {...props}>
          <StyledSpan>
            {children}
            <Icon icon="external-link" size="sm" />
          </StyledSpan>
        </a>
      )
    case Elements.list:
      return <CustomList key={key}> {children} </CustomList>
    case Elements.listItem:
      return (
        <li key={key}>
          {" "}
          <Icon icon="check" />
          {children}{" "}
        </li>
      )
    default:
      return null
  }
}

function Content({ content, serializer }) {
  if (content === null) return null
  const rest = {
    linkResolver: linkResolver,
    htmlSerializer: serializer || htmlSerializer,
  }
  return <RichText render={content} {...rest} />
}

export default Content

Content.propTypes = {
  content: PropTypes.array.isRequired,
}
